import { UnisphereRuntimeLoader, UnisphereRuntimeVisual } from "@unisphere/runtime-react";
import { useMemo } from "react";
import { useConfig } from "@kaltura/mediaspace-shared-data-kms-config/useConfig";
import { ChatRuntimeName, WidgetName } from "@unisphere/genie-core";
import { widgetName as PlgWidgetName, WidgetsRuntimeName } from "@kaltura-corp/unisphere-plg-types";
import { styled } from "@mui/material";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { buildBaseGenieSettings, getGenieContext, getCategoryUrl } from "./helper";
import { usePlgWidgetSettings } from "./usePlgWidgetSettings";
import { type BaseGenieProps } from "./types";

/*
 * Genie floating button
 * renders a floating genie button that opens a floating genie widget
 * used in no-ds pages
 */
export const GenieFloater = ({
    ks,
    categoryData,
    agentMode = false,
    entryData,
    visualType = "floater-cta",
    mode = "everywhere",
}: BaseGenieProps) => {
    const {
        application: { partnerId },
    } = useConfig();

    const categoryUrl = useMemo(() => getCategoryUrl(categoryData), [categoryData]);

    const settings = useMemo(
        () => buildBaseGenieSettings({ ks, partnerId, agentMode, categoryData, categoryUrl, entryData, mode }),
        [ks, partnerId, agentMode, categoryData, categoryUrl, entryData, mode]
    );

    const visualSettings = useMemo(() => {
        const context = getGenieContext({ entryData, categoryData });
        return {
            mode: "everywhere",
            ...(context ? { context } : {}),
        };
    }, [entryData, categoryData]);

    const plgWidgetSettings = usePlgWidgetSettings(ks);

    return (
        <StyledOuterWrapper>
            <UnisphereRuntimeLoader
                widgetName={WidgetName}
                runtimeName={ChatRuntimeName}
                runtimeSettings={settings as unknown as Record<string, unknown>}
            />
            <UnisphereRuntimeLoader
                widgetName={PlgWidgetName}
                runtimeName={WidgetsRuntimeName}
                runtimeSettings={plgWidgetSettings as unknown as Record<string, unknown>}
            />
            <UnisphereRuntimeVisual
                visualSettings={visualSettings}
                visualType={visualType}
                widgetName={WidgetName}
                runtimeName={ChatRuntimeName}
            />
        </StyledOuterWrapper>
    );
};

const StyledOuterWrapper = styled(Box)({
    position: "relative",
    width: "100%",
    height: "100%",
});
